<script setup lang="ts">
import { type Component, computed } from 'vue';

import CustomerSupportWidget from '@/components/VisionAi/widgets/CustomerSupportWidget.vue';
import LegacyDashboardReportsWidget from '@/components/VisionAi/widgets/LegacyDashboardReportsWidget.vue';
import LibraryMediaWidget from '@/components/VisionAi/widgets/LibraryMediaWidget.vue';
import MetricCardWidget from '@/components/VisionAi/widgets/MetricCardWidget.vue';
import type { VisionWidget } from '@/components/VisionAi/widgets/visionWidget.types.ts';

const props = withDefaults(
  defineProps<{
    widgets?: VisionWidget[];
    compact?: boolean;
  }>(),
  { widgets: () => [], compact: false },
);

const emit = defineEmits<{
  onWidgetClick: [interaction: string];
}>();

const WIDGET_COMPONENT_MAP: Record<string, Component> = {
  customer_support: CustomerSupportWidget,
  legacy_dashboards_report: LegacyDashboardReportsWidget,
  library_media: LibraryMediaWidget,
  library_media_group: LibraryMediaWidget,
  metric_card: MetricCardWidget,
};

const WIDGET_LAYOUT_MAP: Record<string, 'column' | 'row'> = {
  library_media_group: 'row',
};

const resolvedWidgets = computed(() =>
  props.widgets
    .map((widget, index) => ({
      component: WIDGET_COMPONENT_MAP[widget.type],
      data: widget.data,
      layout: WIDGET_LAYOUT_MAP[widget.type],
      key: `unified-widget-${index}`,
    }))
    .filter((entry) => entry.component),
);
</script>

<template>
  <component
    :is="entry.component"
    v-for="entry in resolvedWidgets"
    :key="entry.key"
    :widget-data="entry.data"
    :layout="entry.layout"
    :compact="props.compact"
    @on-widget-click="emit('onWidgetClick', $event)"
  />
</template>
